<div>
  <div class="title">Адрес самовывоза</div>
  <ui-address-suggestions-select
    placeholder="ближайший к вам адрес"
    (changeAddress)="onChangeAddress($event)"
  ></ui-address-suggestions-select>
  <div
    class="map-wrapper"
    [ngClass]="{ 'wrapper-error': !!error }"
    [ngbTooltip]="errorMessage"
    tooltipClass="error-tooltip"
    [autoClose]="false"
    triggers="manual"
    #errorTooltip="ngbTooltip"
  >
    <div #shopListRef class="left-content" data-analytics="my_shop_list">
      <sd-pickup-shop-list-desktop-single
        *ngIf="activeShop$ | async as activeShop; else leftContentList"
        [shop]="activeShop"
        (back)="resetActive()"
        (select)="confirmShop(activeShop.name)"
      ></sd-pickup-shop-list-desktop-single>

      <ng-template #leftContentList>
        <sd-pickup-shop-list-desktop-list
          [shops]="shopsSorted$ | async"
          (shopClick)="clickToListShop($event)"
        ></sd-pickup-shop-list-desktop-list>
      </ng-template>
    </div>
    <sd-shops-map
      *ngIf="environmentService.isPlatformBrowser"
      [shops]="shopList"
      [activeShopId]="activeId$ | async"
      [getShopPlacemarkProperties]="getShopPlacemarkProperties"
      class="map-pickup"
      (created)="onMapCreated($event)"
    ></sd-shops-map>
  </div>
</div>
